import { TextField } from "@mui/material";
import React, { PropsWithChildren, type JSX } from 'react';
import { Controller, useFormContext } from "react-hook-form";
import { FormFieldPropsBase } from "../form/Form";
import { useMask } from "@react-input/mask";

export type FormFeetAndInchesMaskProps = {
    boldOnDirty?: boolean;        
    rules?: any;
        onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
        onBlur?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
    
} & FormFieldPropsBase;

export default function FormFeetAndInchesMask({
    name,
    id,
    testId,
    label,
    ariaLabel,
    //readOnly,
    boldOnDirty,
    helperText,
    rules,
    sx,
    disabled,
    onChange,
    onBlur,
    size
}: PropsWithChildren<FormFeetAndInchesMaskProps>): JSX.Element {
    const { control } = useFormContext();

    const inputRef = useMask({ 
            // mask: "__:__:__", 
            // showMask: true,
            // replacement: { _: /\d/ },
            mask: `___' __.__"`,
            showMask: true,
            replacement: { _: /[ 0-9]/ }

        });    

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={
                ({
                    field: { 
                        //ref, 
                        //name, 
                        value, 
                        onChange: onFieldChange, 
                        onBlur 
                    },
                    fieldState: { 
                        invalid, 
                        //isTouched, 
                        isDirty, 
                        error 
                    },
                    //formState
                }: {
                    field: any;
                    fieldState: any;
                    formState: any;
                }) => (
                    <TextField
                        variant="filled"
                        id={id}
                        data-testid={testId}
                        aria-label={ariaLabel ?? undefined}
                        label={label ?? undefined}
                        error={invalid}
                        helperText={invalid ? error.message : helperText}
                        onBlur={onBlur}
                        onChange={
                            (e) => {
                                onFieldChange(e);
                                onChange && onChange(e);
                            }
                        }
                        defaultValue={value}
                        sx={{
                            marginTop: 0,
                            ...sx
                        }}
                        disabled={disabled}
                        size={size}
                        slotProps={{
                            input: {
                                inputRef: inputRef,
                                    sx: {
                                        fontWeight: boldOnDirty && isDirty ? 700 : 400
                                    },
                            },

                            inputLabel: {
                                shrink: true,

                            }
                        }} />
                )
            }
        />
    );
}